export default {
    roomMap: {
        mapTitle: '',
        thumbnailUrl: '',
        largeUrl: '',
        location: {
            x: -1,
            y: -1
        }
    },
    isLoading: false,
    hasErrored: false,
    errMsg: '',

    userReg: {
        ssoToken: '',
        exchangeToken: ''
    },

    outlookItem: {
        type: '',
        readOnly: true,
        location: '',
        recipients: {
            byEmail: [],
            byHash: {}
        }
    },

    license: {
        validLicense: true,
        licenseChecked: false,
        tenantSignedUp: false
    },

    personMap: {
        mapTitle: '',
        thumbnailUrl: '',
        largeUrl: '',
        location: {
            x: -1,
            y: -1
        },
        selectedUser: {},
        isLoading: false,
        errMsg: ''
    },


  };